export class Tooltip {
  constructor({ greaterThanOrEqual, lessThan }) {
    this.greaterThanOrEqual = greaterThanOrEqual
    this.lessThan = lessThan
  }

  getGreaterThanOrEqual() {
    return this.greaterThanOrEqual
  }

  getLessThan() {
    return this.lessThan
  }
}

export class Cause {
  constructor({ startAmount, endAmount }) {
    this.startAmount = startAmount
    this.endAmount = endAmount
  }

  getStartAmount() {
    return this.startAmount
  }

  getEndAmount() {
    return this.endAmount
  }
}

class Discount {
  constructor({ id, cause, discountAmount, tooltip }) {
    this.id = id
    this.cause = new Cause(cause)
    this.discountAmount = discountAmount
    this.tooltip = new Tooltip(tooltip)
  }

  getId() {
    return this.id
  }

  getStandardAmount() {
    return this.standardAmount
  }

  getCause() {
    return this.cause
  }

  getDiscountAmount() {
    return this.discountAmount
  }

  getTooltip() {
    return this.tooltip
  }
}

export default Discount
